/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    modalTextBox: {
      paddingRight: theme.spacing(1.25),
      marginBottom: theme.spacing(2.5),
    },
    modalFormContent: {
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing(2),
    },
    errorText: {
      color: theme.palette.error.main,
      fontSize: theme.spacing(1.5),
      fontWeight: "normal",
    },
    dropDownText: {
      "& #dropdown-inputlabel-IDPDropdown": {
        fontSize: theme.spacing(2.35),
      },
    },
    label: {
      display: "inline-flex",
      alignItems: "center",
    },
    dropDownWrap: {
      display: "flex",
      paddingRight: theme.spacing(1.25),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4.5),
      width: "102%",
    },
    dropDown: {
      width: "100%",
    },
  })
);
